import type {
  AutoWithdrawalAmountMode,
  AutoWithdrawalAssetCode,
  AutoWithdrawalNetworkCode,
  AutoWithdrawalRoutingMode,
} from '@shared/api/contracts';

export type AutoWithdrawalSettingsStatus = 'none' | 'pending' | 'partial' | 'active';

export interface AutoWithdrawalPair {
  key: string;
  assetCode: AutoWithdrawalAssetCode;
  networkCode: AutoWithdrawalNetworkCode;
  group: 'TRC20' | 'ERC20' | 'BEP20' | 'BTC' | 'LTC';
}

export const AUTO_WITHDRAWAL_PAIRS: readonly AutoWithdrawalPair[] = [
  { key: 'USDT:TRC20', assetCode: 'USDT', networkCode: 'TRC20', group: 'TRC20' },
  { key: 'TRX:TRC20', assetCode: 'TRX', networkCode: 'TRC20', group: 'TRC20' },
  { key: 'USDT:ERC20', assetCode: 'USDT', networkCode: 'ERC20', group: 'ERC20' },
  { key: 'ETH:ERC20', assetCode: 'ETH', networkCode: 'ERC20', group: 'ERC20' },
  { key: 'USDT:BEP20', assetCode: 'USDT', networkCode: 'BEP20', group: 'BEP20' },
  { key: 'BNB:BEP20', assetCode: 'BNB', networkCode: 'BEP20', group: 'BEP20' },
  { key: 'BTC:BTC', assetCode: 'BTC', networkCode: 'BTC', group: 'BTC' },
  { key: 'LTC:LTC', assetCode: 'LTC', networkCode: 'LTC', group: 'LTC' },
] as const;

export const SINGLE_USDT_NETWORKS: readonly AutoWithdrawalNetworkCode[] = [
  'TRC20',
  'ERC20',
  'BEP20',
];

export interface AutoWithdrawalRuleDraft {
  key: string;
  assetCode: AutoWithdrawalAssetCode;
  networkCode: AutoWithdrawalNetworkCode;
  destinationAddress: string;
  thresholdAmount: string;
  amountMode: AutoWithdrawalAmountMode;
  reserveAmount: string;
  enabled: boolean;
  hasVerification: boolean | null;
  persistedAddress: string | null;
  visualOrder: number;
}

export interface AutoWithdrawalDrafts {
  routingMode: AutoWithdrawalRoutingMode;
  singleDraft: AutoWithdrawalRuleDraft;
  directDrafts: AutoWithdrawalRuleDraft[];
}

export const getAutoWithdrawalPairKey = (
  assetCode: string,
  networkCode: string,
): string => `${assetCode.trim().toUpperCase()}:${networkCode.trim().toUpperCase()}`;

export const isSupportedAutoWithdrawalPair = (
  assetCode: string,
  networkCode: string,
): boolean => AUTO_WITHDRAWAL_PAIRS.some((pair) => pair.key === getAutoWithdrawalPairKey(assetCode, networkCode));
